module.exports = "<div class=\"container\">\r\n    <img src=\"./assets/img/error.svg\">\r\n    <span>{{'error' | translate}} {{message}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/betting/error/error-message.component.html
// module id = ../../../../../src/app/betting/error/error-message.component.html
// module chunks = 1